"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiscLocalizedReferenceSchema = void 0;
exports.MiscLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/misc.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "MiscLocalizedReference",
    "description": "This content type is used whenever there's a need for a very flexible, rich body asset that doesn't fit our existing types and has limited use cases, hence not requiring a distinct content type.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:misc"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWlzYy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9yZWZlcmVuY2UvbG9jYWxpemVkL2NvbnRlbnQvbWlzYy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw0QkFBNEIsR0FBRztJQUMxQyxLQUFLLEVBQUUsOEVBQThFO0lBQ3JGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHdCQUF3QjtJQUNqQyxhQUFhLEVBQUUsb01BQW9NO0lBQ25OLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixJQUFJO0tBQ0w7SUFDRCxZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUU7Z0JBQ04sa0JBQWtCO2FBQ25CO1lBQ0QsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsaUdBQWlHO1NBQzdHO0tBQ0Y7Q0FDRixDQUFBIn0=